// extracted by mini-css-extract-plugin
module.exports = {"mainPanels":"MainPanels_mainPanels__tj8wy","item":"MainPanels_item__zscaN"};